<template>
  <div
    :class="[
      'approval-card',
      { 'approval-card--expanded': expanded },
      { 'approval-card--approved': item.status === 'approved' },
    ]"
    @click="handleClick"
  >
    <div class="approval-card__inner">
      <!-- Header content -->
      <div :class="['approval-card__content', { 'approval-card__content--bordered': expanded }]">
        <!-- Title row -->
        <div class="approval-card__title-row">
          <div class="approval-card__title-icon">
            <!-- Clock-bill icon -->
            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.4375 8.625H8.4375C8.28832 8.625 8.14524 8.56574 8.03975 8.46025C7.93426 8.35476 7.875 8.21168 7.875 8.0625V3.5625C7.875 3.41332 7.93426 3.27024 8.03975 3.16475C8.14524 3.05926 8.28832 3 8.4375 3C8.58668 3 8.72976 3.05926 8.83525 3.16475C8.94074 3.27024 9 3.41332 9 3.5625V7.5H11.4375C11.5867 7.5 11.7298 7.55926 11.8352 7.66475C11.9407 7.77024 12 7.91332 12 8.0625C12 8.21168 11.9407 8.35476 11.8352 8.46025C11.7298 8.56574 11.5867 8.625 11.4375 8.625ZM9 0C4.8585 0 1.5 3.3585 1.5 7.5V7.527C1.623 7.509 1.74825 7.5 1.87575 7.5H4.87575C5.57194 7.5 6.23962 7.77656 6.73191 8.26884C7.22419 8.76113 7.50075 9.42881 7.50075 10.125V14.625C7.50075 14.7 7.49775 14.7745 7.49175 14.8485C7.97975 14.9485 8.4825 14.999 9 15C13.1415 15 16.5 11.6415 16.5 7.5C16.5 3.3585 13.1415 0 9 0ZM0 10.125C0 9.62772 0.197544 9.15081 0.549175 8.79918C0.900805 8.44754 1.37772 8.25 1.875 8.25H4.875C5.37228 8.25 5.84919 8.44754 6.20083 8.79918C6.55246 9.15081 6.75 9.62772 6.75 10.125V14.625C6.75 15.1223 6.55246 15.5992 6.20083 15.9508C5.84919 16.3025 5.37228 16.5 4.875 16.5H1.875C1.37772 16.5 0.900805 16.3025 0.549175 15.9508C0.197544 15.5992 0 15.1223 0 14.625V10.125ZM4.875 9.75H1.875C1.77554 9.75 1.68016 9.78951 1.60984 9.85983C1.53951 9.93016 1.5 10.0255 1.5 10.125C1.5 10.2245 1.53951 10.3198 1.60984 10.3902C1.68016 10.4605 1.77554 10.5 1.875 10.5H4.875C4.97446 10.5 5.06984 10.4605 5.14016 10.3902C5.21049 10.3198 5.25 10.2245 5.25 10.125C5.25 10.0255 5.21049 9.93016 5.14016 9.85983C5.06984 9.78951 4.97446 9.75 4.875 9.75ZM4.875 12H1.875C1.77554 12 1.68016 12.0395 1.60984 12.1098C1.53951 12.1802 1.5 12.2755 1.5 12.375C1.5 12.4745 1.53951 12.5698 1.60984 12.6402C1.68016 12.7105 1.77554 12.75 1.875 12.75H4.875C4.97446 12.75 5.06984 12.7105 5.14016 12.6402C5.21049 12.5698 5.25 12.4745 5.25 12.375C5.25 12.2755 5.21049 12.1802 5.14016 12.1098C5.06984 12.0395 4.97446 12 4.875 12ZM4.875 14.25H1.875C1.77554 14.25 1.68016 14.2895 1.60984 14.3598C1.53951 14.4302 1.5 14.5255 1.5 14.625C1.5 14.7245 1.53951 14.8198 1.60984 14.8902C1.68016 14.9605 1.77554 15 1.875 15H4.875C4.97446 15 5.06984 14.9605 5.14016 14.8902C5.21049 14.8198 5.25 14.7245 5.25 14.625C5.25 14.5255 5.21049 14.4302 5.14016 14.3598C5.06984 14.2895 4.97446 14.25 4.875 14.25Z" fill="#EC4899"/>
            </svg>
            <span class="approval-card__title-text">Pending Approval</span>
            <!-- Status tag -->
            <span v-if="item.status === 'approved'" class="approval-card__tag approval-card__tag--approved">Action Approved</span>
            <span v-else class="approval-card__tag approval-card__tag--required">Action Required</span>
          </div>
          <div class="approval-card__time-actions">
            <span class="approval-card__time">{{ item.timeAgo }}</span>
            <!-- Archive icon -->
            <div class="approval-card__archive-wrap" @click.stop="$emit('archive', item.id)">
              <svg class="approval-card__archive-icon" width="18" height="18" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.5 0H1.5C0.75 0 0 0.675 0 1.5V3.7575C0 4.2975 0.3225 4.7625 0.75 5.025V13.5C0.75 14.325 1.575 15 2.25 15H12.75C13.425 15 14.25 14.325 14.25 13.5V5.025C14.6775 4.7625 15 4.2975 15 3.7575V1.5C15 0.675 14.25 0 13.5 0ZM12.75 13.5H2.25V5.25H12.75V13.5ZM13.5 3.75H1.5V1.5H13.5V3.75Z" fill="#374957"/>
                <path d="M9.75 7.5H5.25V9H9.75V7.5Z" fill="#374957"/>
              </svg>
              <div class="approval-card__archive-tooltip">Archive</div>
            </div>
          </div>
        </div>
        <!-- Descriptions -->
        <div class="approval-card__descriptions">
          <div class="approval-card__patient">
            <span class="approval-card__patient-label">Patient:</span>
            <span class="approval-card__patient-name">{{ item.patientName }}</span>
          </div>
          <p class="approval-card__description">{{ item.description }}</p>
        </div>
      </div>

      <!-- Expandable content -->
      <transition
        @before-enter="beforeEnter"
        @enter="enter"
        @after-enter="afterEnter"
        @before-leave="beforeLeave"
        @leave="leave"
        @after-leave="afterLeave"
      >
        <div v-if="expanded" class="approval-card__expandable">
          <!-- Approved state: gray bubble -->
          <div v-if="item.status === 'approved'" class="approval-card__result">
            <div class="approval-card__result-title">{{ item.approvedTitle || 'Action completed' }}</div>
            <div class="approval-card__result-body">
              <div v-if="item.promptContent" class="approval-card__preview">
                <p class="approval-card__preview-label">Message Preview:</p>
                <p class="approval-card__preview-text">{{ item.promptContent }}</p>
              </div>
            </div>
          </div>

          <!-- Pending state: yellow prompt bubble -->
          <div v-else class="approval-card__prompt">
            <!-- Prompt title -->
            <div class="approval-card__prompt-title">{{ item.promptTitle || 'Ready to perform this action' }}</div>
            <!-- Message preview -->
            <div class="approval-card__prompt-body">
              <div v-if="item.promptContent" class="approval-card__preview">
                <p class="approval-card__preview-label">Message Preview:</p>
                <p class="approval-card__preview-text">{{ item.promptContent }}</p>
              </div>
              <!-- Buttons -->
              <div class="approval-card__btn-group" @click.stop>
                <button
                  class="approval-card__btn approval-card__btn--approve"
                  :disabled="approving || rejecting"
                  @click="$emit('approve', item.id)"
                >
                  {{ approving ? 'Approving...' : 'Approve' }}
                </button>
                <button
                  class="approval-card__btn approval-card__btn--cancel"
                  :disabled="approving || rejecting"
                  @click="$emit('reject', item.id)"
                >
                  {{ rejecting ? 'Cancelling...' : 'Cancel' }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApprovalCard',
  props: {
    item: { type: Object, required: true },
    expanded: { type: Boolean, default: false },
    approving: { type: Boolean, default: false },
    rejecting: { type: Boolean, default: false },
  },
  emits: ['approve', 'reject', 'toggle-expand', 'archive'],
  methods: {
    handleClick() {
      this.$emit('toggle-expand', this.item.id);
    },
    /* Expand/collapse transition hooks */
    beforeEnter(el) {
      el.style.height = '0';
      el.style.opacity = '0';
      el.style.overflow = 'hidden';
    },
    enter(el, done) {
      void el.offsetHeight;
      el.style.transition = 'height 0.3s ease, opacity 0.3s ease';
      el.style.height = el.scrollHeight + 'px';
      el.style.opacity = '1';
      el.addEventListener('transitionend', done, { once: true });
    },
    afterEnter(el) {
      el.style.height = '';
      el.style.overflow = '';
      el.style.transition = '';
    },
    beforeLeave(el) {
      el.style.height = el.scrollHeight + 'px';
      el.style.overflow = 'hidden';
    },
    leave(el, done) {
      void el.offsetHeight;
      el.style.transition = 'height 0.3s ease, opacity 0.3s ease';
      el.style.height = '0';
      el.style.opacity = '0';
      el.addEventListener('transitionend', done, { once: true });
    },
    afterLeave(el) {
      el.style.height = '';
      el.style.overflow = '';
      el.style.transition = '';
    },
  },
};
</script>

<style scoped>
.approval-card {
  border-left: 4px solid #EC4899;
  border-radius: 0 10px 10px 0;
  min-height: 132px;
  flex: 1;
  min-width: 0;
  cursor: pointer;
  overflow: hidden;
  display: flex;
  background: #fff;
}

.approval-card:hover,
.approval-card--expanded {
  background: #FFF6FA;
  box-shadow: 0px 4px 12px rgba(26, 32, 44, 0.06);
}

.approval-card__inner {
  border: 1px solid #E0E0E0;
  border-left: none;
  border-radius: 0 10px 10px 0;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1;
}

.approval-card__content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.approval-card__content--bordered {
  border-bottom: 1px dashed #C4C4C4;
  padding-bottom: 12px;
}

.approval-card__title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.approval-card__title-icon {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
}

.approval-card__title-icon svg {
  flex-shrink: 0;
}

.approval-card__title-text {
  font-family: Inter, sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #374957;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.approval-card__tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  padding: 1px 10px;
  border-radius: 23px;
  font-family: Inter, sans-serif;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  white-space: nowrap;
  flex-shrink: 0;
}

.approval-card__tag--required {
  background: #FAF1D3;
  border: 1px solid #FAF1D3;
  color: #CB9F12;
}

.approval-card__tag--approved {
  background: #E5F9EF;
  border: 1px solid #E5F9EF;
  color: #20A7C1;
}

.approval-card__time-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.approval-card__time {
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: #666;
  white-space: nowrap;
}

.approval-card__archive-wrap {
  position: relative;
  flex-shrink: 0;
  cursor: pointer;
}

.approval-card__archive-icon {
  display: block;
}

.approval-card__archive-tooltip {
  display: none;
  position: absolute;
  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  background: #666;
  color: #fff;
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  white-space: nowrap;
  padding: 4px 12px;
  border-radius: 2px;
  box-shadow: 0px 4px 12px rgba(26, 32, 44, 0.06);
  z-index: 10;
}

.approval-card__archive-tooltip::before {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-bottom-color: #666;
}

.approval-card__archive-wrap:hover .approval-card__archive-tooltip {
  display: block;
}

.approval-card__descriptions {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.approval-card__patient {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  white-space: nowrap;
}

.approval-card__patient-label {
  color: #999;
}

.approval-card__patient-name {
  color: #666;
}

.approval-card__description {
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.2px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin: 0;
}

/* Expandable wrapper */
.approval-card__expandable {
  display: flex;
  flex-direction: column;
}

/* Pending state: yellow prompt bubble */
.approval-card__prompt {
  background: #FEF9E9;
  border: 1px solid #F1C21B;
  border-radius: 10px;
  padding: 12px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.approval-card__prompt-title {
  font-family: Inter, sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #9E3900;
}

.approval-card__prompt-body {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Approved state: gray result bubble */
.approval-card__result {
  background: #F2F2F2;
  border-radius: 10px;
  padding: 12px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.approval-card__result-title {
  font-family: Inter, sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #333;
}

.approval-card__result-body {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Message preview card (shared between pending & approved) */
.approval-card__preview {
  background: #fff;
  border-radius: 10px;
  padding: 10px 20px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.approval-card__preview-label {
  font-family: Inter, sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: #999;
  margin: 0;
}

.approval-card__preview-text {
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #333;
  margin: 0;
}

/* Button group */
.approval-card__btn-group {
  display: flex;
  gap: 11px;
  height: 32px;
}

.approval-card__btn {
  height: 32px;
  padding: 4px 32px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  font-family: Inter, sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.1px;
  white-space: nowrap;
  text-align: center;
  box-shadow: 0px 1px 3px 0px rgba(74, 74, 74, 0.25);
}

.approval-card__btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.approval-card__btn--approve {
  background: #81B0E1;
  color: #fff;
  flex: 1;
  min-width: 0;
}

.approval-card__btn--approve:hover:not(:disabled) {
  background: #6A9DD4;
}

.approval-card__btn--cancel {
  background: #fff;
  color: #1E4670;
  border: 1px solid #1E4670;
  padding: 4px 24px;
  flex-shrink: 0;
}

.approval-card__btn--cancel:hover:not(:disabled) {
  background: #F5F8FB;
}
</style>
